import type { RegisterOptions } from "react-hook-form";

export const EMAIL_REQUIRED_MESSAGE = "Email is required";
export const EMAIL_INVALID_MESSAGE = "Please enter a valid email address";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value);
}

export function validateEmail(value: string): true | string {
  return isValidEmail(value) || EMAIL_INVALID_MESSAGE;
}

/** Standard react-hook-form rules for required email fields. */
export const emailFieldRules = {
  required: EMAIL_REQUIRED_MESSAGE,
  validate: validateEmail,
} satisfies Pick<RegisterOptions, "required" | "validate">;
